import {BdpkTask} from './domain/bdpk-task';
import {DxObjectMapper} from '../dx-core/services/dx-object-mapper.service';
import {BdpkScheduleLogItem} from './domain/bdpk-schedule-log-item';
import {BdpkSchedule} from './domain/bdpk-schedule';


export class BdpkTasksMocksProvider {

  public static provideSchedulerLogsMocks(): object[] {
    const logs: BdpkScheduleLogItem[] = [];

/*
    let item: BdpkScheduleLogItem = new BdpkScheduleLogItem();
    item.id = 1;
    item.scheduleId = 1;
    item.scheduleName = 'Запуск ETL-задачи';
    item.objectId = 1;
    item.objectName ='ETL-задача JOB формата';
    item.runFactDateTime = new Date(2020, 1 , 1);
    item.statusName = 'OK';
    item.result = 'Успешно';
    item.comment = 'Загружено 12 345 450 записей';
    logs.push(item);

    item = new BdpkScheduleLogItem();
    item.id = 2;
    item.scheduleId = 2;
    item.scheduleName = 'Запуск ETL-задачи';
    item.objectId = 2;
    item.objectName ='ETL-задача формата трансформации';
    item.runFactDateTime = new Date(2020, 1 , 2);
    item.statusName = 'OK';
    item.result = 'Успешно';
    item.comment = 'Обработано 12 345 420 записей, пропущено 30 записей';
    logs.push(item);

    item = new BdpkScheduleLogItem();
    item.id = 3;
    item.scheduleId = 3;
    item.scheduleName = 'Запуск кластеризации';
    item.objectId = 3;
    item.objectName ='Кластеризация пользователей';
    item.runFactDateTime = new Date(2020, 1 , 3);
    item.statusName = 'ERROR';
    item.result = 'Ошибка';
    item.comment = 'Среда запуска не доступна';
    logs.push(item);
*/


    return DxObjectMapper.toPlainArray(logs, BdpkScheduleLogItem);
  }

  public static provideSchedulesMocks(): Object[] {
    const logs: BdpkSchedule[] = [];

/*
    let item: BdpkSchedule = new BdpkSchedule();
    item.objectId = 1;
    item.objectName = 'ETL-задача JOB формата';
    item.scheduleId = 1;
    item.name = 'Запуск ETL-задачи';
    item.changeUserName = '_admin';
    item.schedulePeriodName = 'ежедневно';
    item.objectId = 1;
    item.changeDate = new Date(2020, 1 , 1);
    item.runDate ='10.02.2020';
    item.runTime ='05:00';
    item.scheduleParams = '-t -l 20148';
    logs.push(item);

    item = new BdpkSchedule();
    item.objectId = 2;
    item.objectName = 'ETL-задача формата трансформации';
    item.scheduleId = 2;
    item.name = 'Запуск ETL-задачи трансформации';
    item.changeUserName = '_admin';
    item.schedulePeriodName = 'единожды';
    item.objectId = 1;
    item.changeDate = new Date(2020, 1 , 2);
    item.runDate ='03.02.2020';
    item.runTime ='07:00';
    item.scheduleParams = '-iterations:10 -threads:4';
    logs.push(item);
*/

    return DxObjectMapper.toPlainArray(logs, BdpkSchedule);
  }


  public static provideTasksMocks(): Object[] {
    const tasks: BdpkTask[] = [];

/*
    let task: BdpkTask = new BdpkTask();
    task.id = 1;
    task.name = 'Анализ данных портала ЕКАС ОП';
    task.description = 'Цель: повышение используемости портала ЕКАС ОП жителями Пермского края';
    task.author = 'Министерство информационного развития и связи';
    task.lastUpdate = new Date(2020, 0, 20);
    task.isFavorite = true;
    task.image = 'assets/img/bdpk-tasks/dataanalysis.svg';
    tasks.push(task);


    task = new BdpkTask();
    task.id = 2;
    task.name = 'Оптимизация размещения медицинских организаций для обеспечения доступности первичной медико-санитарной помощи';
    task.description = 'Цель: обеспечение доступности для населения  первичной медико-санитарной помощь в Пермском крае';
    task.author = 'Министерство здравоохранения ';
    task.lastUpdate = new Date(2019, 11, 1);
    task.isFavorite = false;
    task.image = 'assets/img/bdpk-tasks/medicalhouse.svg';
    tasks.push(task);


    task = new BdpkTask();
    task.id = 3;
    task.name = 'Зависимость успеваемости ребенка от программ дополнительного образования';
    task.description = 'Цель: формирование аналитической информации по успеваемости учеников и ее зависимости от программ доп. образования';
    task.author = 'Министерство образования и науки';
    task.lastUpdate = new Date(2019, 11, 20);
    task.isFavorite = false;
    task.image = 'assets/img/bdpk-tasks/education.svg';
    tasks.push(task);


    task = new BdpkTask();
    task.id = 4;
    task.name = 'Анализ фотографий сельскохозяйственных полей';
    task.description = 'Цель: проведение инвентаризации состояния земель сельскохозяйственного назначения на основе данных дистанционного зондирования Земли';
    task.author = 'Министерство сельского хозяйства и продовольствия ';
    task.lastUpdate = new Date(2019, 10, 15);
    task.isFavorite = false;
    task.image = 'assets/img/bdpk-tasks/pictures.svg';
    tasks.push(task);
*/

    return DxObjectMapper.toPlainArray(tasks, BdpkTask);

  }

}
